/* ===== Product Slider (Dawn置き換え用 / jQuery不要) ===== */
(() => {
  function init(root) {
    if (root.dataset.psliderReady === 'true') return;
    root.dataset.psliderReady = 'true';

    const viewport = root.querySelector('[data-viewport]');
    const slides   = Array.from(root.querySelectorAll('[data-slide]'));
    const thumbsNav = root.querySelector('.pslider__thumbs');
    const thumbs   = Array.from(root.querySelectorAll('[data-thumb]'));
    const prevBtn  = root.querySelector('.pslider__btn--prev');
    const nextBtn  = root.querySelector('.pslider__btn--next');
    const ctaButton = root.querySelector('[data-cta-button]');
    const ctaSpinner = root.querySelector('.pslider__cta-spinner');
    const ctaSoldOut = root.querySelector('[data-cta-soldout]');
    const productInfo = root.closest('product-info');
    const productForm = productInfo?.querySelector('product-form');
    const formElement = productForm?.querySelector('form');
    const submitButton = productForm?.querySelector('[type="submit"]');
    const variantIdInput = productForm?.querySelector('input[name="id"]');
    const formSpinner = productForm?.querySelector('.loading__spinner');

    // モーダル（全画面拡大）
    const modal =
      root.parentElement?.querySelector('[data-pslider-modal]') || document.querySelector('[data-pslider-modal]');
    const modalImg = modal?.querySelector('.pslider__modal-img');
    const mClose   = modal?.querySelector('.m-close');
    const mPrev    = modal?.querySelector('.m-prev');
    const mNext    = modal?.querySelector('.m-next');
    const mCount   = modal?.querySelector('[data-pslider-count]');

    if (!viewport || slides.length === 0) return;
    let index = 0;

    function syncCTAState() {
      if (!ctaButton) return;

      const buttonLabel = submitButton?.querySelector('span')?.textContent?.trim();
      const isUnavailableLabel = Boolean(
        buttonLabel &&
        (buttonLabel === window.variantStrings?.soldOut || buttonLabel === window.variantStrings?.unavailable)
      );
      const isLoading = Boolean(
        submitButton?.classList.contains('loading') ||
        (formSpinner && !formSpinner.classList.contains('hidden'))
      );
      const isUnavailable = Boolean(
        !formElement ||
        !submitButton ||
        !variantIdInput ||
        variantIdInput.disabled ||
        !variantIdInput.value ||
        isUnavailableLabel
      );
      const isTemporarilyDisabled = Boolean(submitButton?.hasAttribute('disabled') && !isUnavailable);

      ctaButton.disabled = isLoading || isUnavailable || isTemporarilyDisabled;
      ctaButton.setAttribute('aria-disabled', ctaButton.disabled ? 'true' : 'false');

      if (ctaSpinner) {
        ctaSpinner.classList.toggle('hidden', !isLoading);
      }

      if (ctaSoldOut) {
        const showMessage = !isLoading && isUnavailable && Boolean(buttonLabel);
        ctaSoldOut.hidden = !showMessage;
        if (showMessage) ctaSoldOut.textContent = buttonLabel;
      }

      ctaButton.hidden = !isLoading && isUnavailable && Boolean(buttonLabel);
    }

    function setIndex(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      syncUI();
    }

    function syncUI() {
      thumbs.forEach((t, i) => t.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      syncThumbScroll();
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    }

    function syncThumbScroll() {
      const activeThumb = thumbs[index];
      if (!thumbsNav || !activeThumb) return;

      const navRect = thumbsNav.getBoundingClientRect();
      const thumbRect = activeThumb.getBoundingClientRect();

      if (thumbRect.left < navRect.left) {
        thumbsNav.scrollBy({ left: thumbRect.left - navRect.left, behavior: 'smooth' });
      } else if (thumbRect.right > navRect.right) {
        thumbsNav.scrollBy({ left: thumbRect.right - navRect.right, behavior: 'smooth' });
      }
    }

    // 監視してスクロールとインデックスを同期
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const i = slides.indexOf(entry.target);
          if (i !== -1) { index = i; syncUI(); }
        }
      });
    }, { root: viewport, threshold: 0.6 });
    slides.forEach(slide => io.observe(slide));

    // サムネイルクリック
    thumbs.forEach((t, i) => t.addEventListener('click', () => setIndex(i)));

    // 矢印
    prevBtn?.addEventListener('click', () => setIndex(index - 1));
    nextBtn?.addEventListener('click', () => setIndex(index + 1));

    ctaButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      syncCTAState();

      if (ctaButton.disabled || !formElement || !submitButton) return;

      if (typeof formElement.requestSubmit === 'function') {
        formElement.requestSubmit(submitButton);
      } else {
        submitButton.click();
      }
    });

    // 画像クリック→モーダル
    slides.forEach((s, i) => {
      const img = s.querySelector('img');
      img?.addEventListener('click', () => {
        index = i;
        openModal();
      });
    });

    function updateModalUI(){
      if (mCount) {
        mCount.textContent = `Image ${index + 1} of ${slides.length}`;
      }
    }

    function openModal() {
      if (!modal || !modalImg) return;

      // 高解像度を優先（data-fullがあれば使う）
      const el = slides[index].querySelector('img');
      modalImg.src = el.getAttribute('data-full') || el.currentSrc || el.src;
      modal.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
      modal.setAttribute('aria-hidden', 'false');
      mClose?.focus();
      updateModalUI();
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('active');
      document.documentElement.style.overflow = '';
      modal.setAttribute('aria-hidden', 'true');
    }
    function modalNext() {
      index = (index + 1) % slides.length;
      openModal();
    }
    function modalPrev() {
      index = (index - 1 + slides.length) % slides.length;
      openModal();
    }

    mClose?.addEventListener('click', closeModal);
    mNext?.addEventListener('click', modalNext);
    mPrev?.addEventListener('click', modalPrev);
    modal?.addEventListener('click', (e) => {
      if (e.target === modal) closeModal(); // 背景クリックで閉じる
    });
    document.addEventListener('keydown', (e) => {
      if (!modal?.classList.contains('active')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') modalNext();
      if (e.key === 'ArrowLeft')  modalPrev();
    });

    // 初期表示同期
    syncUI();
    syncCTAState();

    variantIdInput?.addEventListener('change', syncCTAState);
    formElement?.addEventListener('submit', () => {
      requestAnimationFrame(syncCTAState);
    });

    if (submitButton) {
      new MutationObserver(syncCTAState).observe(submitButton, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    if (formSpinner) {
      new MutationObserver(syncCTAState).observe(formSpinner, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }

  function boot(container = document) {
    container.querySelectorAll('[data-pslider]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  // セクションの動的読み込み対応
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('product-info:loaded', (event) => boot(event.target));
})();
